import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

SwiperCore.use([EffectFade]);

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');

    const swiperMap = {
        us: ['animL1', 'animL2', 'animL3', 'animL4'],
        ph: ['animL1', 'animL2', 'animL3'],
        kr: ['animL1_kr', 'animL2', 'animL3_kr', 'animL4'],
    };

    const swiperList = swiperMap[locale] || swiperMap.us;

    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationL',
            offset: layoutH * 0.5, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '30%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationL .msg-box',
            0.5,
            {
                opacity: 0,
                ease: 'ease-out',
            },
            {
                opacity: 1,
                ease: 'ease-out',
            },
        );

        sceneA1.setTween(tweenA1);
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationL} animationL GtmModuleData-section`} data-section-id={css.animationL} data-section-title={t('delta2.aniL_msg1')}>
            <div className="static-box">
                <div className="msg-box">
                    <div className="msg-title1 title-bolder">{t('delta2.aniL_msg1')}</div>
                    <div className="msg-title2">{t('delta2.aniL_msg2')}</div>
                </div>
                <div className="img-box">
                    <Swiper
                        modules={[Autoplay, Navigation]}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        className="animL-swiper"
                        slidesPerView={'auto'}
                        initialSlide={0}
                        loop={true}
                        observer={true}
                        observeParents={true}
                        preloadImages={false}
                        lazy={true}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        spaceBetween={18}
                        centeredSlides={true}
                        grabCursor={true}
                        speed={800}
                    >
                        {swiperList.map((item: any, k: number) => (
                            <SwiperSlide key={k}>
                                <EFPic name={[`${item}.webp`, `${item}.jpg`]} className="img" />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
